module.exports = __webpack_public_path__ + "static/harry-potter-the-complete-collection-17-8ec538f1ece8f8124135b50a5b5d41ac.jpg";